<template>
	<div>
		<v-dialog v-model="dialog_note" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
        	  	<v-card-text>
        	  		<v-form data-vv-scope="entryNote">
        	  			<v-textarea 
        	  				text-field-top-bottom-margin
        	  				id="noteField" 
	        	  			v-validate="'max:255'"
		               		data-vv-name="note" 
		               		:error-messages="errors.collect('entryNote.note')" 
		               		rows="10" 
		               		v-model="noteValue"
		               		placeholder=" " 
		               		label="Add Notes" 
		               		:counter="255">
	               		</v-textarea>
        	  		</v-form>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="fn_closeDialog">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_saveNote">done</v-btn>
		        </v-card-actions>
	        	</v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_note: false,
			noteValue:'',
			noteType:null
		}
	},
	methods:{
		openDialogWeb: function (type) {	
			this.dialog_note = true;
			this.noteType = type ? type : null;
		},
		closeDialogWeb: function () {
			this.dialog_note = false;
		},
		fn_closeDialog: function(){
			if(this.$parent.fn_closeDialog){
				this.$parent.fn_closeDialog();
			}
			else{
				this.closeDialogWeb();
			}
		},
		fn_saveNote: function () {
			var self = this;
		    this.$validator.validateAll('entryNote').then((result) => {
		        if (result) {
		           self.$parent.fn_saveNote(self.noteType);
		        }
		    });
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_note.vue